import * as share from './share'
import * as report from './report'
import * as status from './status'
import * as sport from './sport'
import * as my from './my'
import * as trainPlan from './trainPlan'

const apiObj = {
    share,
    report,
    status,
    sport,
    my,
    trainPlan
}

const install = function (Vue) {
    if (install.installed) return
    install.installed = true
    Object.defineProperties(Vue.prototype, {
        $api: {
            get () {
                return apiObj
            }
        }
    })
}
export default {
    install
}



// WEBPACK FOOTER //
// ./src/api/index.js